import { render, staticRenderFns } from "./QuestionnaireDetail.vue?vue&type=template&id=05d3e582&scoped=true&"
import script from "./QuestionnaireDetail.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireDetail.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireDetail.vue?vue&type=style&index=0&id=05d3e582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d3e582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
